import { AppConstant } from './../../config/app.constant';
import { AdminService } from './../../services/admin.service';
import { AppStateProvider } from './../../services/app-state.provider';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

export class EmailTemplate {
  fromId: string;
  toId: string;
  subject: string;
  body: string;
  bcc: string;
}

@Component({
  standalone: false,
  selector: 'app-email-members',
  templateUrl: './email-members.component.html',
  styleUrls: ['./email-members.component.scss'],
})
export class EmailMembersComponent implements OnInit {
  meetingNav: { index: string; name: string; link: string }[];
  emailList = [];
  show: boolean;
  @Input() member;
  token: string;
  url: string;
  memberDetail: any;
  subject;
  body;
  constraint: number = 3;
  toId: string = "bridgeplusbangalore@capitaland.com";

  constructor(
    private router: Router,
    private appStateSrv: AppStateProvider,
    private adminSrv: AdminService,
  ) { }

  ngOnInit(): void {

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    // this.getTOEmailId();
    this.emailList = this.adminSrv.getEmailList();
    if (this.emailList.length == 0) {
      window.history.back();
      return;
    }

    console.log(this.emailList, "email and length ", this.emailList.length);

    this.memberDetail = JSON.parse(
      localStorage.getItem(AppConstant.localStorage.userDetails)
    );

    this.meetingNav = [
      {
        index: '2',
        name: 'Members',
        link: 'members/members-list/email',
      },
    ];

    const route = {
      index: '2',
      name: 'Members',
      link: 'members/members-list/email',
    };
    this.appStateSrv.setSideNavState(route);
  }
  toggleShow() {
    this.show = !this.show;
    this.constraint = this.emailList.length;
  }
  removeItems(email) {
    this.emailList = this.emailList.filter(
      (item) => item !== email
    );
    localStorage.setItem(
      AppConstant.localStorage.emailList,
      JSON.stringify(this.emailList)
    );
    // this.show = false;
    this.adminSrv.setEmailList(this.emailList)
    console.log('this.emil', this.emailList);
  }
  sendemail() {


    if (this.subject == undefined && this.body == undefined) {
      alert('Subject and Body can not be empty');
      return;
    }
    // sub present but not body touched
    if (this.subject !== undefined && this.body == undefined) {
      if (this.subject.length > 4000) {
        alert('subject too long!!');
        return;
      }
      if (this.subject.length !== undefined && this.subject.length !== 0) {
        alert('Body can not be empty');
        return;
      }
      alert('Subject and Body can not be empty');
      return;
    }
    //body present not sub touched
    if (this.body !== undefined && this.subject == undefined) {
      if (this.body.length !== undefined && this.body.length !== 0) {
        alert('Subject can not be empty');
        return;
      }
      alert('Subject and Body can not be empty');
      return;
    }
    if (this.subject !== undefined && this.body !== undefined) {
      if (this.subject.length == 0 && this.body.length == 0) {
        alert('Subject and Body can not be empty');
        return;
      }
      if (this.subject.length == 0) {
        alert('Subject can not be empty');
        return;
      }
      if (this.body.length == 0) {
        alert('body can not be empty');
        return;
      }
    }
    let temp = new EmailTemplate();
    temp.fromId = this.memberDetail.adminEmailId;
    temp.subject = this.subject;
    temp.body = this.body;
    temp.toId = this.toId;
    temp.bcc = '';
    this.emailList.forEach((emails) => {
      temp.bcc = temp.bcc + (temp.bcc == '' ? '' : ';') + emails;
    });
    this.adminSrv.sendEmail(temp).subscribe((response) => {
      console.log('response email ', response);
      localStorage.removeItem(AppConstant.localStorage.emailList);
      history.back();
    });
  }

  cancel() {
    this.router.navigate(['members/members-list']);
  }

  maskName(name: string): string {
    if (!name || !name.trim()) {
      return name;
    }

    return name
      .split(' ')
      .map(word =>
        word.length > 1
          ? word[0] + '*'.repeat(word.length - 1)
          : word
      )
      .join(' ');
  }


  maskPhone(phone: string): string {
    if (!phone) {
      return phone;
    }

    const digits = phone.replace(/\D/g, '');

    if (digits.length < 4) {
      return phone;
    }

    return (
      digits.substring(0, 2) +
      '*'.repeat(digits.length - 4) +
      digits.substring(digits.length - 2)
    );
  }

  maskEmail(email: string): string {
    if (!email) {
      return email;
    }

    const atIndex = email.indexOf('@');

    if (atIndex <= 2) {
      return '*'.repeat(atIndex) + email.substring(atIndex);
    }

    return (
      email.substring(0, 2) +
      '*'.repeat(atIndex - 2) +
      email.substring(atIndex)
    );
  }

}
